export default class SuppressionRule {
    constructor() {
        return {
            restrict: 'A',
            scope: {
                loadedOptions: '='
            },
            controller: [
                '$scope', '$element', '$attrs', '$timeout', '$filter',
                (scope, element, attr, $timeout, $filter) => {
                    $timeout(() => {
                        $(element).selectize({
                            valueField: 'value',
                            labelField: 'name',
                            searchField: 'name',
                            plugins: ['remove_button'],
                            preload: true,
                            create: false,
                            options: [
                                {value: 'email_campaign', name: $filter('translate')('SEGMENTATION:SHOW:SUPPRESSION_OPTIONS:EMAIL_CAMPAIGN')},
                                {value: 'email_transaction', name: $filter('translate')('SEGMENTATION:SHOW:SUPPRESSION_OPTIONS:EMAIL_TRANSACTION')},
                                {value: 'sms_campaign', name: $filter('translate')('SEGMENTATION:SHOW:SUPPRESSION_OPTIONS:SMS_CAMPAIGN')},
                                {value: 'sms_transaction', name: $filter('translate')('SEGMENTATION:SHOW:SUPPRESSION_OPTIONS:SMS_TRANSACTION')},
                            ]
                        })[0].selectize.setValue(scope.loadedOptions);
                    })
                }]
        }
    }
}
